import { onLoad }           from 'Core/Events';

export const TruncateElement = (() => {

    const Selector = {
        PRODUCT_TILE     : '.product-tile--container',
    };

    onLoad(multiLineElipsis);

    function multiLineElipsis() {
        const containers = document.querySelectorAll(Selector.PRODUCT_TILE);
        Array.prototype.forEach.call(containers, (container) => {  // Loop through each container
            var p = container.querySelector('p');
            var divh = container.clientHeight;
            while (p.offsetHeight > divh) { // Check if the paragraph's height is taller than the container's height. If it is:
                p.textContent = p.textContent.replace(/\W*\s(\S)*$/, '...'); // add an ellipsis at the last shown space
            }
        })
    }
})();import { onLoad }           from 'Core/Events';

export const TruncateElement = (() => {

    const Selector = {
        PRODUCT_TILE     : '.product-tile--container',
    };

    onLoad(multiLineElipsis);

    function multiLineElipsis() {
        const containers = document.querySelectorAll(Selector.PRODUCT_TILE);
        Array.prototype.forEach.call(containers, (container) => {  // Loop through each container
            var p = container.querySelector('p');
            var divh = container.clientHeight;
            while (p.offsetHeight > divh) { // Check if the paragraph's height is taller than the container's height. If it is:
                p.textContent = p.textContent.replace(/\W*\s(\S)*$/, '...'); // add an ellipsis at the last shown space
            }
        })
    }
})();